import { render, staticRenderFns } from "./dataRow.vue?vue&type=template&id=7013ca74&scoped=true&"
import script from "./dataRow.vue?vue&type=script&lang=js&"
export * from "./dataRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013ca74",
  null
  
)

export default component.exports